export const es = {
  'AppName': 'Reclamaciones de PG&E',
  "Calendar": "Calendario",
  "ShowTimePicker": "Mostrar selector de hora",
  'Questionnaire': 'Cuestionario',
  'ClaimantHeading': 'Información del reclamante',
  "IncidentInformationHeading": "Información del incidente",
  "ClaimDetailsHeading": "Detalles de la reclamación",
  "Witnesses": "Testigos",
  "Supporting_documents": "Documentos de respaldo",
  "Confirmation": "Confirmación",
  "Stepper_1": "1. Cuestionario",
  "Stepper_2": "2. Información del reclamante",
  "Stepper_3": "3. Información del incidente",
  "Stepper_4": "4. Detalles de la reclamación",
  "Stepper_5": "5. Testigos",
  "Stepper_6": "6. Documentos de respaldo",
  "Stepper_7": "7. Confirmación",
  "QuestionnaireDesc": "Entendemos que ha sufrido una pérdida de la que cree que PG&E puede ser responsable. Para evaluar su reclamación, proporcione la siguiente información.",
  "InitialQuestion1":"¿Su reclamación está relacionada con una tormenta, un corte de energía o una interrupción del suministro eléctrico por motivos de seguridad pública?",
  "Yes": "Sí",
  "No": "No",
  "QuestionnaireDescYes": "Si usted es un cliente residencial que ha estado sin electricidad durante 48 horas consecutivas o más debido a condiciones de tormenta severa, puede calificar para un pago automático bajo nuestro programa Safety Net. Este programa proporciona un pago de $25 a $100, que pagamos automáticamente unos 60 días después del corte por la tormenta.",
  "QuestionnaireMoreInfo": "Para obtener más información sobre los pagos del programa Safety Net",
  "QuestionnaireMoreInfoLink": " visite Compensación por cortes",
  "QuestionnaireAutomaticProgram": "Este es un programa automático basado en la elegibilidad; no se requiere ninguna acción adicional.",
  "FullStop": ". ",
  "InitialQuestion": "¿Aún desea presentar una reclamación? (SÍ/NO)",
  "InitialQuestion3Info": "En general, PG&E no se hace responsable de los daños que no cause o que sean el resultado de fuerzas ajenas a nuestro control. Por ejemplo, en la mayoría de los casos, no somos responsables en las siguientes situaciones: Cortes de energía, fluctuaciones de voltaje o daños a la propiedad causados por condiciones relacionadas con el clima, como rayos, inundaciones, tormentas, vegetación (árboles/ramas), calor o vientos, terremotos u otros actos de la naturaleza.",
  "Error": "Error: Seleccione una respuesta",
  "Next": "Siguiente",
  "Helpline": "Si tiene problemas para enviar su reclamación en línea, póngase en contacto con la línea de ayuda para reclamaciones de PG&E al",
  "ForAssistance.": "para obtener ayuda.",
  "Information": "Información",
  "RequiredField": "*campo obligatorio",
  "AccountNumber": "Número de cuenta de PG&E",
  "AccountNumberTooltip": "Su número de cuenta se encuentra en la esquina superior derecha de su estado de cuenta de energía mensual de PG&E.",
  "AccountNumberOptional": "Este campo es opcional.",
  "accountnumber": "número_de_cuenta",
  "InvalidAcNmbr": "número de cuenta no válido",
  "BusinessName": "Nombre de la empresa",
  "FirstName":"Nombre",
  "LastName":"Apellido",
  "MailingAddress":"Dirección postal",
  "AptSuite":"Apto./Suite",
  "City":"Ciudad",
  "ZIPCode":"Código postal",
  "State":"Estado",
  "PhoneNumber": "Número de teléfono",
  "PrimaryPhone":"Número de teléfono principal",
  "AlternatePhone":"Número de teléfono alternativo",
  "Email":"Dirección de correo electrónico",
  "ConfirmEmail":"Confirmar dirección de correo electrónico",
  "AreYouPG&EEmployee":"¿Es empleado de PG&E?",
  "PGEEmployee": "Empleado de PG&E",
  "LANID":"ID de LAN",
  "Back": "Atrás",
  "ErrorAccountNumberDigits": "Error: Ingrese al menos 10 dígitos",
  "ErrorFirstNameRequired": "Error: El nombre es obligatorio",
  "ErrorLastNameRequired": "Error: El apellido es obligatorio",
  "ErrorMailingAddressRequired": "Error: La dirección postal es obligatoria",
  "ErrorCityRequired": "Error: La ciudad es obligatoria",
  "ErrorZipCodeRequired": "Error: Ingrese el código postal",
  "ErrorPhneNumbrRequired": "Error: Ingrese un número de teléfono válido",
  "ErrorPhoneNumber10Digits": "Error: Debe ingresar un número de teléfono de 10 dígitos",
  "ErrorValidEmail": "Error: Ingrese una dirección de correo electrónico válida",
  "ErrorEmailsMustMatch": "Error: Las direcciones de correo electrónico deben coincidir",
  "ErrorPGEEmployeeRequired": "Error: ¿Trabaja actualmente para PG&E? Si no es así, seleccione No arriba",
  "ErrorLANIDRequired": "Error: El ID de LAN es obligatorio",
  "ErrorLANIDValid": "Error: Ingrese un ID de LAN válido",
  "EstimatedDateOfIncident": "Fecha estimada del incidente",
  "IncDate": "mm/dd/aaaa",
  "EstimatedTimeOfIncident": "Hora estimada del incidente (si se conoce)",
  "Today": "hoy",
  "SameAsMailingAddress": "¿Igual que la dirección postal?",
  "Location": "*Ubicación",
  "StreetAddress": "Calle",
  "OtherDescribe": "Otro/Describir",
  "IncidentAddress": "Dirección del incidente",
  "DescriptionOfLocation": "Descripción de la ubicación",
  "YouHave": "Le quedan",
  "CharactersRemaining": "caracteres",
  "ErrorPleaseEnterValidDate": "Error: Ingrese una fecha válida",
  "ErrorValidDateFormat": "Error: Ingrese una fecha válida en formato MM/DD/AAAA",
  "ErrorFutureDateNotAllowed": "Error: No se permite una fecha futura",
  "ErrorYearCurrentCentury": "Error: El año debe estar en el siglo actual", 
  "ErrorValidTime12Hour": "Error: Ingrese una hora válida en formato de 12 horas",
  "ErrorOneSelectionRequired": "Error: Se requiere una selección",  
  "ErrorIncidentAddressRequired": "Error: La dirección del incidente es obligatoria",  
  "ErrorLocationDescriptionRequired": "Error: La descripción de la ubicación es obligatoria",  
  "DescribeWhatHappened": "*Describa lo que sucedió",  
  "Subtotal": "Subtotal",
  "IsThisClaimForBusiness": "¿Esta es una reclamación para su empresa?",
  "EstimatedRevenueLoss": "Pérdida de ingresos estimada",
  "WagesPaidToHourlyEmployees": "Salarios pagados a empleados por hora",
  "LostInventory": "Inventario perdido",
  "WereYouInjured": "¿Sufrió lesiones?",
  "IncidentInvolves": "El incidente implica",
  "BodilyInjury": "Lesión corporal",
  "PropertyDamageFoodSpoilageLabel": "Daño a la propiedad/deterioro de alimentos",
  "PropertyDamageOrFoodSpoilage": "Daños a la propiedad o deterioro de alimentos",
  "Both": "Ambos",
  "IsThisMotorVehicleIncident": "¿Se trata de un incidente con un vehículo motorizado?",
  "VehicleInfo": "Información del vehículo",
  "CarMake": "Marca del automóvil",
  "CarModel": "Modelo de automóvil",
  "CarYear": "Año del automóvil",
  "EstimatedDamages": "Daños estimados",
  "LicensePlateNumber": "Número de matrícula",
  "StateRegistered": "Estado registrado",
  "IsClaimantOwnerOfVehicle": "¿Es el reclamante propietario del vehículo?",
  "VehicleOwnerInformation": "Información del propietario del vehículo",
  "VehicleOwnerFirstName": "Nombre del propietario del vehículo",
  "VehicleOwnerLastName": "Apellido del propietario del vehículo",
  "Address": "Dirección",
  "Select": "Seleccionar",
  "LostWages": "Salarios perdidos (si los hubiera)",
  "MedicalExpenses": "Gastos médicos (si los hubiera)",
  "OtherLosses": "Otras pérdidas",
  "PleaseDescribeOtherLosses": "Describa las otras pérdidas",
  "TotalAmountClaimed": "Monto total reclamado",
  "DamagedItems": "Artículos dañados (distintos del vehículo)",
  "AddItem": "Agregar artículo",
  "DeleteItem": "Eliminar elemento",
  "DeleteItemConfirmation": "¿Le gustaría eliminar el elemento?",
  "Delete": "Borrar",
  "NoteMoreThan10Items": "Nota: Si tiene más de 10 artículos, agregue una lista de artículos como archivo adjunto en el paso 4.",
  "UpdateItem": "Actualizar elemento",
  "MakeBrand": "Fabricante/Marca",
  "Model": "Modelo",
  "Year": "Año",
  "Amount": "*Monto",
  "ItemDescription": "*Descripción del artículo",
  "Makebrand": "Fabricante/Marca",
  "Itemdescription": "*Descripción del artículo",
  "Submit": "Enviar",
  "Cancel": "Cancelar",
  "ErrorDetailedDescriptionRequired": "Error: Se requiere una descripción detallada",  
  "ErrorBusinessNameRequired": "Error: El nombre de la empresa es obligatorio",
  "ErrorCarMakeRequired": "Error: La marca del automóvil es obligatoria",
  "ErrorCarModelRequired": "Error: El modelo del automóvil es obligatorio",
  "ErrorCarYearRequired": "Error: El año del automóvil es obligatorio",
  "ErrorEstimatedDamagesRequired": "Error: Los daños estimados son obligatorios.",
  "ErrorLicensePlateNumberRequired": "Error: El número de matrícula es obligatorio.",
  "ErrorItemDescriptionRequired": "Error: La descripción del artículo es obligatoria",
  "ErrorAmountRequired": "Error: El monto es obligatorio",
  "ErrorInvalidAmountEntry": "Error: Entrada de monto no válida. Ingrese un valor entre 0.00 y 10000000.00",
  "ErrorPleaseChooseOptionIncidentInvolves": "Error: Elija una opción para El incidente implica",
  "ErrorVehicleOwnerFirstNameRequired": "Error: El nombre del propietario del vehículo es obligatorio",
  "ErrorVehicleOwnerLastNameRequired": "Error: El apellido del propietario del vehículo es obligatorio",
  "ErrorVehicleOwnerAddressRequired": "Error: La dirección del propietario del vehículo es obligatoria",
  "ErrorVehicleOwnerCityRequired": "Error: La ciudad del propietario del vehículo es obligatoria",
  "ErrorVehicleOwnerStateRequired": "Error: El estado del propietario del vehículo es obligatorio",
  "ErrorValidZipCode": "Error: Ingrese un código postal válido",
  "ErrorValidZipCodeNumber": "Error: Ingrese un código postal válido (por ejemplo, 12345, 94538)",
  "ErrorVehicleOwnerPhoneRequired": "Error: El teléfono del propietario del vehículo es obligatorio",
  "ErrorClaimantOwnerOfVehicle": "Error: Elija una opción para ¿Es el reclamante propietario del vehículo?",
  "ErrorMotorVehicleIncident": "Error: Elija una opción. ¿Se trata de un incidente con un vehículo motorizado?",
  "ErrorClaimForBusiness": "Error: Elija una opción. ¿Esta es una reclamación para su empresa?",
  "WitnessesHeading": "Testigos (opcional)",
  "WitnessesDescription": "Si no hubo testigos, puede omitir este paso. Esto es típico para las reclamaciones relacionadas con lesiones. Puede agregar hasta tres testigos.",
  "Phone": "Teléfono",
  "ZIP": "Código postal",
  "Firstname": "Nombre",
  "Lastname": "Apellido",
  "PGnEEmployee": "Empleado de PGE",
  "ResultsWillAppearInTable": "Los resultados aparecerán en una tabla a continuación.",
  "AddWitness": "Agregar un testigo",
  "ErrorMaxThreeWitnesses": "Error: Puede añadir hasta tres testigos.",
  "UpdateWitness": "Actualizar testigo",
  "DeleteWitness": "DEliminar testigo",
  "DeleteWitnessConfirmation": "¿Te gustaría eliminar al testigo?",
  "ErrorPleaseEnter" :"Error: Ingrese",
  "ValidZip": "un código postal válido" ,
  "ZipCodeExample": "(p. ej.: 12345, 94538)",
  "SupportingDocumentsHeading": "Agregar documentos de respaldo",
  "ProcessClaimsDescription": "Para procesar sus reclamaciones, necesitaremos documentos de respaldo para cada artículo reclamado.",
  "AddUpTo10Documents": "Agregue hasta 10 documentos (p. ej., recibos y estimaciones)",
  "FilesLessThan10MB": "Los archivos deben tener menos de 10 MB cada uno",
  "FileTypesAccepted": "Tipos de archivos aceptados: .pdf,.txt,.doc,.docx,.xls,.xlsx,.jpg,.png,.heic o .jpeg.",
  "NOTE": "NOTA:",
  "NoteClaimsRepresentative": "Su representante de reclamaciones se comunicará con usted en el término de los próximos 3 días hábiles. Pueden ayudarle si tiene más de 10 documentos o si tiene información adicional.",
  "AttachFile": "Adjuntar archivo",
  "AttachFileInstruction1": "Haga clic en el ícono de carga [",
  "AttachFileInstruction1End": "] y seleccione el archivo desde su escritorio.",
  "AttachFileInstruction2": "Haga clic en el botón Cargar.",
  "AttachFileInstruction3": "Los archivos aparecerán como una lista a continuación.",
  "MaxFileSize": "Tamaño máx. de archivo: 10 MB",
  "Upload": "Cargar", 
  "Agreement": "Acuerdo",
  "FileNotUploaded": "Archivo no cargado",
  "ErrorUploadDocument": "Error: Hemos encontrado un problema al procesar el documento que ha subido. Por favor, suba el documento nuevamente.",
  "FileNotUploadedMessage": "No ha cargado el archivo seleccionado. Haga clic en el botón [Cargar ^] ",
  "AgreementTerms": "*Al enviar este formulario entiendo que Pacific Gas and Electric Company revisará toda la documentación que respalde esta reclamación. Certifico que la información anterior ingresada es verdadera y correcta.",
  "Security": "Seguridad",
  "VerifyNotRobot": "Verifique que no es un robot.",
  "ErrorReadAgreeTerms": "Error: Lea y acepte los términos.",
  "ErrorVerifyNotRobot": "Error: Verifique que no es un robot",
  "SubmitWithoutAttachment": "Enviar sin archivo adjunto",
  "SubmitWithoutUploadingDocuments": "¿Desea enviar esta reclamación sin cargar documentos?",
  "SubmitAnyway": "Enviar de todos modos",
  "DontSubmit": "No enviar",
  "ErrorSubmitForm": "Error: Hemos encontrado un problema al procesar su formulario. Por favor, envíe el formulario nuevamente.",
  "ErrorFileSizeLessThan10MB": "Error: El tamaño del archivo debe ser inferior a 10 MB.",
  "ErrorProcessingRequest": "Error: Hemos encontrado un problema al procesar su solicitud. Por favor, verifique que haya ingresado toda la información requerida y vuelva a enviarla.",
  "ErrorAllowedFileTypes": "Error: Tipos de archivo permitidos .pdf,.txt,.doc,.docx,.xls,.xlsx,.jpg,.png,.heic,.jpeg",
  "FilesAttached": "Archivos adjuntos",
  "Ok": "De acuerdo",
  "Recaptcha": "recaptcha",
  "ConfirmationHeading": "Se ha recibido su presentación de reclamación.",
  "YourClaimNumberIs": "Su número de reclamación es",
  "ConfirmationDescription": "La política de Pacific Gas and Electric Company es responder de forma rápida y justa a las reclamaciones de los clientes. Todas las reclamaciones se evalúan caso por caso. Nuestro objetivo es resolver su reclamación dentro de los 30 días posteriores a su recibo. Sin embargo, algunas reclamaciones tardan más en investigarse y resolverse. Al enviar la documentación de respaldo de su pérdida de inmediato, se acelerará el trámite de su reclamación. Una vez finalizada nuestra investigación, le llamaremos o le enviaremos una carta explicando lo que encontramos y los fundamentos de nuestra decisión.",
  "WhatToExpect": "Qué esperar",
  "ConfirmationDocument": "Si no ha proporcionado documentos de respaldo O tiene documentos adicionales para enviar (p. ej., recibo o estimaciones de artículos reclamados), envíe dicha documentación a:",
  "ConfirmationDocumentEmail": "claimsdocs@pge.com?subject=",
  "HelpDesk": "Si tiene alguna pregunta, puede comunicarse con nuestro servicio de asistencia al 415-973-4548.",
  "Sincerely": "Atentamente,",
  "PGEClaimsTeam": "Equipo de reclamaciones de PG&E",
  "Age": "Edad",
  "Action": "Acción",
  "Edit": "Editar",
  "Add": "Agregar",
  "ErrorFileAlreadyUploaded": "Error: Ya se ha subido un archivo con el mismo nombre.",
  "InfoBannerText": "Si tiene problemas para enviar su reclamación en línea, póngase en contacto con la línea de ayuda para reclamaciones de PG&E al (415) 973-4548 para obtener ayuda.",
  "SessionExpire15": "Su sesión caducará en 15 minutos.",
  "SessionExpire5": "Su sesión caducará en 5 minutos.",
  "SessionExpireWarning": "Por razones de seguridad, sus datos se eliminarán cuando la sesión expire.",
  "StayConnected": "Mantente conectada",
  "EndSession": "Finalizar sesión",
  "SessionExpired": "Su sesión ha caducado debido a la inactividad.",
  "SessionDeleted": "Por razones de seguridad, sus datos han sido eliminados.",
  "Accessibility": "Accesibilidad",
  "TermsAndConditions": "Términos y condiciones",
  "Regulation": "Regulación",
  "Privacy": "Privacidad",
  "DoNotSellMyPersonalInformation": "No vender mi información personal",
  "SiteMap": "Mapa del sitio",
  "CopyrightText": "Pacific Gas and Electric Company",
  "DeleteFile": "Eliminar un archivo",
  "RemoveUploadedFileConfirmation": "¿Le gustaría eliminar el archivo subido?",
  "RemoveFile": "Eliminar archivo",
  "NoFileChosen": "Ningún archivo seleccionado",
  "arrowUP": "Una flecha apunta hacia arriba para indicar la carga de un archivo"
};